import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICDOriginalCode } from '@core/model';

@Component({
    selector: 'diagnosis-original-codes',
    templateUrl: './diagnosis-original-codes.component.html',
    styleUrls: ['./diagnosis-original-codes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DiagnosisOriginalCodesComponent {
  @Input() originalCodes: ICDOriginalCode[] = [];
}
